// removed by extract-text-webpack-plugin
module.exports = {"trustPilot":"TrustPilotInline-m__trustPilot___1jDvA","trustPilotLogo":"TrustPilotInline-m__trustPilotLogo___TE4z4","trustPilotStars":"TrustPilotInline-m__trustPilotStars___2S_Dn","trustPilotStar":"TrustPilotInline-m__trustPilotStar___1OcVD","trustPilotExcellent":"TrustPilotInline-m__trustPilotExcellent___1qFzG"};


//////////////////
// WEBPACK FOOTER
// ./components/trustPilot/TrustPilotInline.m.sass
// module id = U0lT
// module chunks = 0